import {RFixTradeBtnWrapper, RTradeBtn, RDetailTab} from "../../../styles/responsive/CommonStyles";
import {Flex} from "../../../styles/MarketStyles";
import Text from "../../../utils/Text";
import {fadeVariants} from "../../../utils/theme";
import {motion} from 'framer-motion'
import RMarketDetails from "./RMarketDetails";
import TradingChart from "../../chart/TradingChart";
import {useState} from "react";
import OrdersBook from "../../orderbox/OrdersBook";
import LastTrades from "../../LastTrades";
import DepthChart from "../../chart/DepthChart";

const tabs = ['order-book', 'last-trades']

const RMain = ({ onTradeBtnClicked }) => {

    const [activeTab, setActiveTab] = useState(0)

    return (
        <motion.div
            variants={fadeVariants}
            initial={'out'}
            animate={'in'}
            exit={'out'}
            style={{ width: '100%', height: '100%', paddingBottom: '50px' }}
        >
            <RMarketDetails />
            <Flex fw height={'320px'}>
                <TradingChart isMain/>
            </Flex>
            <DepthChart />
            <Flex fw justify={'flex-start'}>
                { tabs.map((tab, idx) => (
                    <RDetailTab active={activeTab === idx} onClick={() => setActiveTab(idx)}>
                        <Text tid={tab} />
                    </RDetailTab>
                ))}
            </Flex>
            <Flex fw>
                {activeTab === 0 &&
                    <Flex fw height={'320px'}>
                        <OrdersBook />
                    </Flex>
                }
                {activeTab === 1 && <LastTrades />}
            </Flex>

            <RFixTradeBtnWrapper>
                <Flex fw fh justify={'space-around'}>
                    {['buy', 'sell'].map(type => (
                        <RTradeBtn type={type} onClick={() => onTradeBtnClicked(type)}>
                            <Text tid={type} />
                        </RTradeBtn>
                    ))}
                </Flex>
            </RFixTradeBtnWrapper>
        </motion.div>
    )
}

export default RMain
